import { Component } from '@angular/core';
@Component({
  selector: 'app-league-content-session-types-report',
  templateUrl: './league-content-session-types-report.component.html'
})
export class LeagueContentSessionTypesReportComponent {
}
